import styled from 'styled-components';

export const ManagerPanel = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  width: ${({ $collapsed }) => ($collapsed ? '32px' : '276px')};
  border-right: 1px solid #f1f3f5;
  transition: width 0.2s ease;
  overflow: hidden;
`;
export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
`;
export const UniqueBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  padding: 2px 8px;
  cursor: default;
  user-select: none;
  white-space: nowrap;
  border-left: 1px solid #6b6b6bbc;
  color: #7b7b7bf1;
`;

export const FundsSectionWrapper = styled.div`
  flex: 1;
  min-width: 0;
  overflow: auto;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 16px;
  margin-top: 8px;
  border-top: 1px solid #f1f3f5;
  background: white;
`;
